function initMobileMenu(){
    //Mobi menu
    $('body .hamburger').on('click',function () {
        $('body').toggleClass('mobi-menu-open')
        $(this).toggleClass('is-active')
    })

    $(document).on('click','.mobi-menu-open .sub-opener',function (e) {
      e.preventDefault();
        $(this).closest('li').toggleClass('sub-open');
      $(this).closest('li').find('ul').slideToggle();
    })
    fixedHeader();
    fixedHeaderSlideInAndOut();
}

$(window).on('resize',function () {
    fixedHeader();
});

function fixedHeader() {

    if(window.matchMedia('(max-width:992px)').matches){
        var fixedHeaderHeight = $('.page-header .interaction').outerHeight();
        $('.page-header').css('margin-top',fixedHeaderHeight + 'px')
        $('.page-header .interaction').addClass('fixed')
    }else{
        $('.page-header .interaction').removeClass('fixed')
        $('.page-header').attr('style','');
    }
}

function fixedHeaderSlideInAndOut() {
    var scrollUpPoint = '992px';
    var navControl = $('.page-header .interaction').first();

    $(document).on('scrollUp', function () {
        if (window.matchMedia("(max-width: "+scrollUpPoint+")").matches) {
            //show the menu only if we are a bit over the bottom. So we avoid to trigger the menu on ios, when the user scrolls hard to the bottom and the animation of ios gos over the window limits and scrolls up
            var maxScrollHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
            //avoid stupid ios bounce fuck off
            if (maxScrollHeight - $(window).scrollTop() > 100) {
                navControl.animate({
                    top: 0
                }, 150)
            }
        }
    });
    $(document).on('scrollDown', function () {
        if (window.matchMedia("(max-width: " + scrollUpPoint + ")").matches) {
            if ($(window).scrollTop() > 100) {
                navControl.animate({
                    top: (navControl.outerHeight() + 15 ) * -1
                });
            }
        }
    });
}